/*
 * ml-umami.js · los eventos de la tienda, también en Umami
 * ══════════════════════════════════════════════════════════════════════
 *
 * Del 12/10/2026, pedido por Ricardo. La vista de página la cuenta el
 * rastreador de Umami solo, con las UTM de la dirección; esto le añade lo
 * que pasa DENTRO de la página. Lo carga snippets/ml-umami.liquid en todas
 * las páginas, detrás del rastreador. El porqué entero, en
 * analitica/UMAMI.md.
 *
 * NO MIDE NADA POR SU CUENTA: escucha las mismas dos señales que escucha
 * assets/ml-contador.js, en el mismo punto, y no toca el contador.
 *
 *   · «ml-medicion:nombre», que avisa assets/ml-medicion-video.js con el
 *     nombre de cada evento que manda: el vídeo de Vimeo de las landings A
 *     y B y los tres clics de la landing B, que le llegan de
 *     assets/ml-leccion.js. Ahí ya está toda la lógica de progreso, con lo
 *     medido y probado: los hitos son de COBERTURA —segundos vistos de
 *     verdad, no la posición del cabezal—, así que saltar al final no
 *     cuenta como «visto entero».
 *   · «klaviyoForms» con type «submit»: el ENVÍO de un formulario de
 *     Klaviyo, en cualquier página. Ni abrirlo, ni un paso, ni cerrarlo.
 *
 * LOS NOMBRES, los que pidió Ricardo para Umami:
 *
 *   vimeo_start           → video_play       el vídeo empieza a sonar
 *   vimeo_25, _50, _75    → video_25, _50, _75
 *   vimeo_complete        → video_complete   el 95 % visto
 *   lead_offer_click      → resumen_click    clic en el resumen (landing B)
 *   generate_lead         → resumen_request  piden el resumen (landing B)
 *   course_product_click  → curso_click      clic en el curso (landing B)
 *   klaviyoForms submit   → form_submit
 *
 * video_play sale del ARRANQUE y no del botón: vimeo_play salta en cada
 * «play», también al reanudar, y vimeo_start una sola vez, cuando el vídeo
 * suena de verdad. Es el mismo criterio que el embudo de GA4.
 *
 * CADA UNO, COMO MUCHO UNA VEZ POR CARGA, con «landing» —la ruta de la
 * página— y, si aplica, «video_id» —el número del vídeo de Vimeo— o
 * «form_id» —el del formulario de Klaviyo—. Nada más: del evento de
 * Klaviyo se lee SOLO formId; el correo viaja en él y aquí no se toca.
 *
 * Y si window.umami no está —un bloqueador ha cortado el rastreador—, no se
 * manda nada y no se rompe nada. No hace falta cola: este guion y el
 * rastreador van diferidos y en ese orden, así que cuando esto corre el
 * rastreador ya ha corrido o ya ha fallado. Lo vigila N93.
 */
(function () {
  'use strict';
  if (window.mlUmami) { return; }
  window.mlUmami = true;

  var NOMBRES = {
    vimeo_start: 'video_play',
    vimeo_25: 'video_25',
    vimeo_50: 'video_50',
    vimeo_75: 'video_75',
    vimeo_complete: 'video_complete',
    lead_offer_click: 'resumen_click',
    generate_lead: 'resumen_request',
    course_product_click: 'curso_click'
  };
  var DEL_VIDEO = { video_play: 1, video_25: 1, video_50: 1, video_75: 1, video_complete: 1 };
  var mandado = {};

  /* El vídeo se busca al mandar y no al cargar: en la landing B el iframe
     lo pone la portada al tocarla, y antes no existe. */
  function idDelVideo() {
    var iframe = document.querySelector('iframe[src*="player.vimeo.com/video/"]');
    var m = iframe ? /player\.vimeo\.com\/video\/(\d+)/.exec(iframe.getAttribute('src') || '') : null;
    return m ? m[1] : '';
  }

  function mandar(nombre, extra) {
    if (mandado[nombre]) { return; }
    mandado[nombre] = true;
    if (!window.umami || typeof window.umami.track !== 'function') { return; }
    var datos = { landing: window.location.pathname };
    for (var k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k]) { datos[k] = extra[k]; }
    }
    /* umami.track es asíncrona y devuelve una promesa. Si rechaza y nadie la
       recoge, el navegador la cuenta como error y Clarity también, que es lo
       que pasó el 26/08/2026 con las transiciones de Horizon (CLAUDE.md, «un
       error de JavaScript no siempre revienta algo»). Así que se recoge. */
    var promesa = window.umami.track(nombre, datos);
    if (promesa && typeof promesa.catch === 'function') { promesa.catch(function () {}); }
  }

  document.addEventListener('ml-medicion:nombre', function (e) {
    var nombre = e && typeof e.detail === 'string' && Object.prototype.hasOwnProperty.call(NOMBRES, e.detail)
      ? NOMBRES[e.detail] : '';
    if (!nombre) { return; }
    mandar(nombre, DEL_VIDEO[nombre] ? { video_id: idDelVideo() } : {});
  });

  /* Solo letras, números, guion y guion bajo, y corto: un id de formulario
     de Klaviyo es así —Va5MGz, S6BAc6—, y cualquier otra cosa no se manda. */
  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail || e.detail.type !== 'submit') { return; }
    var id = String(e.detail.formId || '');
    mandar('form_submit', { form_id: /^[A-Za-z0-9_-]{1,40}$/.test(id) ? id : '' });
  });
})();
